<template>
    <div>
        <div :class="[isExpanded ? 'expanded-panel': 'hidden-panel',
                      controlPanelIsHovered && !isExpanded ? 'control-panel-hovered': '']"
             class="panel">
            <div v-show="!isExpanded && animationIsEnd && this.$route.name === 'forMisha'" class="message-404">
                <span class="message">Ну или пожалуйтесь на нас 😔</span>
                <img class="arrow" src="../../public/arrow.png">
            </div>
            <div @click="callEmitToogleExpandState()"
                 @mouseover="controlPanelIsHovered=true"
                 @mouseleave="controlPanelIsHovered=false"
                 :class="[!isExpanded && animationIsEnd && controlPanelIsHovered ? 'shadow' : '']"
                 class="control-panel">
                <i v-if="isExpanded" class="fas fa-arrow-circle-right"></i>
                <i v-else class="far fa-question-circle"></i>
            </div>
            <div
                @click="controlPanelIsHovered && !isExpanded ? callEmitToogleExpandState() : ''"
                @mouseover="controlPanelIsHovered=true"
                @mouseleave="controlPanelIsHovered=false"
                class="content">
                <slot></slot>
            </div>
        </div>
        <div @click="callEmitToogleExpandState" class="background"></div>
    </div>
</template>

<script>
  export default {
    name: "RightSidebar",
    data() {
      return {
        animationIsEnd: true,
        controlPanelIsHovered: false
      }
    },
    props: {
      isExpanded: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      callEmitToogleExpandState() {
        this.$emit('toogleExpandState')
      }
    },
    watch: {
      isExpanded(value) {
        this.isExpanded = value
        this.animationIsEnd = false
        setTimeout(() => this.animationIsEnd = true, 440)
      }
    }
  }
</script>

<!--Bubble-left-animation-->
<style scoped>
    .hvr-bubble-left {
        display: inline-block;
        vertical-align: middle;
        -webkit-transform: perspective(1px) translateZ(0);
        transform: perspective(1px) translateZ(0);
        box-shadow: 0 0 1px rgba(0, 0, 0, 0);
        position: relative;
    }
    .hvr-bubble-left:before {
        pointer-events: none;
        position: absolute;
        z-index: -1;
        content: '';
        border-style: solid;
        -webkit-transition-duration: 0.3s;
        transition-duration: 0.3s;
        -webkit-transition-property: transform;
        transition-property: transform;
        top: calc(50% - 10px);
        left: 0;
        border-width: 10px 10px 10px 0;
        border-color: transparent #ffffff transparent transparent;
    }
    .hvr-bubble-left:hover:before, .hvr-bubble-left:focus:before, .hvr-bubble-left:active:before {
        -webkit-transform: translateX(-10px);
        transform: translateX(-10px);
    }
</style>

<style lang="sass" scoped>
    @import '../assets/sass/animations'

    @keyframes name-of-animation
        0%
            transform: translateX(0)
        50%
            transform: translateX(7px)
        100%
            transform: translateX(0)

    .control-panel-hovered
        right: -490px !important


    .control-panel
        &:hover
            .fa-arrow-circle-right
                animation: 1s infinite name-of-animation

    .background
        transition: 1s
        opacity: 0
        top: 0
        left: 0
        z-index: 1
        right: 0
        bottom: 0
        pointer-events: none
        background: gray
        position: fixed


    .expanded-panel
        &~.background
            pointer-events: auto
            opacity: .5


    .message-404
        position: absolute
        left: -120px
        top: 230px
        .message
            position: absolute
            width: 240px
            left: -100px
            top: -10px
            color: black
            font-weight: bold
            transform: rotate(320deg)
        .arrow
            width: 100px
            transform: scaleY(-1) rotate(280deg)


    .expanded-panel
        right: 60px

    .hidden-panel
        right: -510px

    .control-panel
        display: flex
        justify-content: center
        align-items: center
        width: gridSteps(3)
        min-width: gridSteps(3)
        height: gridSteps(6)
        border-bottom-left-radius: 2px
        border-top-left-radius: 2px
        background: white
        margin: gridSteps(-3)
        align-self: center

    .shadow:hover
        transition: 0.3s
        /*box-shadow: $standard-elevation*/


    .content
        margin-left: gridSteps(3)
        padding: gridSteps(3)
        width: 100%
        height: 100%

    .panel
        position: fixed
        top: 50%
        display: flex
        transform: translate(0, -50%)
        margin: 10px
        z-index: 3
        width: 500px
        transition: 0.5s
        align-self: center
        background: white
        box-shadow: $standard-elevation
</style>
